import { useMemo } from 'react';
import { useCurrentProductHasAppliedFilters } from '../../../filters/filters-helper-functions';
import { useQuery } from '../../../query-context';
import { filterFirstSectionItems, mergeFirstSectionSearchItems } from './faster-search-helpers';
/**
 * This component abstracts the faster search logic. Faster search kicks in when user types a query
 * and is waiting for the API resposne to return. We filter out at max 3 preQuery items from the first section
 * and show it to the user and once the response from the API is available we append it to the existing results
 * and dedupe them.
 *
 * We do this by default only for the first section because we consider thats it is the most relevant and important for the user.
 *
 * @returns a callback function with the intermediate/faster search results and post query results combined.
 */
export var FasterSearchFirstSection = function FasterSearchFirstSection(_ref) {
  var postQueryItems = _ref.postQueryItems,
    preQueryItems = _ref.preQueryItems,
    children = _ref.children;
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var hasFilters = useCurrentProductHasAppliedFilters();
  var intermediateItems = useMemo(function () {
    return filterFirstSectionItems(preQueryItems, query, hasFilters ? 0 : 3);
  }, [preQueryItems, query, hasFilters]);
  var resultItems = useMemo(function () {
    return postQueryItems ? mergeFirstSectionSearchItems(intermediateItems, postQueryItems) : intermediateItems;
  }, [intermediateItems, postQueryItems]);
  var firstSectionResultItems = {
    size: resultItems.size,
    sections: resultItems.sections.length > 0 ? [resultItems.sections[0]] : []
  };
  return children({
    searchItems: firstSectionResultItems
  });
};